import { useMemo } from 'react';

import type { CommandProviderArgs } from './command-provider.types';

type ScopeContext = {
  type: 'scope';
  scopeType: 'flows' | 'devices' | 'settings' | 'logs' | string;
};

type DeviceContext = {
  type: 'device';
  deviceName: string;
};

type FlowContext = {
  type: 'flow';
  flowName: string;
};

type AppContext = {
  type: 'app';
  appName: string;
};

type SettingContext = {
  type: 'setting';
  settingTitle: string;
};

type PaletteContext = ScopeContext | DeviceContext | FlowContext | AppContext | SettingContext;

export function useInputPlaceholder(
  activeContext: PaletteContext | null | undefined,
  i18n: CommandProviderArgs['i18n'],
): string {
  return useMemo(() => {
    if (activeContext?.type === 'scope' && activeContext.scopeType === 'flows') {
      return i18n.messageFormatter('commandPalette.placeholders.searchFlows');
    }

    if (activeContext?.type === 'scope' && activeContext.scopeType === 'devices') {
      return i18n.messageFormatter('commandPalette.placeholders.searchDevices');
    }

    if (activeContext?.type === 'scope' && activeContext.scopeType === 'settings') {
      return i18n.messageFormatter('commandPalette.placeholders.searchSettings');
    }

    if (activeContext?.type === 'scope' && activeContext.scopeType === 'logs') {
      return i18n.messageFormatter('commandPalette.placeholders.searchLogs');
    }

    if (activeContext?.type === 'device') {
      return i18n.messageFormatter('commandPalette.placeholders.searchActions', {
        name: activeContext.deviceName,
      });
    }

    if (activeContext?.type === 'flow') {
      return i18n.messageFormatter('commandPalette.placeholders.searchActions', {
        name: activeContext.flowName,
      });
    }

    if (activeContext?.type === 'app') {
      return i18n.messageFormatter('commandPalette.placeholders.searchActions', {
        name: activeContext.appName,
      });
    }

    if (activeContext?.type === 'setting') {
      return i18n.messageFormatter('commandPalette.placeholders.searchActions', {
        name: activeContext.settingTitle,
      });
    }

    return i18n.messageFormatter('commandPalette.placeholders.searchCommands');
  }, [activeContext, i18n]);
}
